function toDate(time) {
    
    let date = new Date(time)
   
    let year = date.getFullYear()
    let month = (date.getMonth() + 1).toString().padStart(2, '0')
    let day = date.getDate().toString().padStart(2, '0')
    let hours = date.getHours().toString().padStart(2, '0')
    let minutes = date.getMinutes().toString().padStart(2, '0')
    let seconds = date.getSeconds().toString().padStart(2, '0')
    let milliSeconds = date.getMilliseconds()
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliSeconds}Z`
}

function toDay(time) {
    var date = new Date(time) // 传入的时间单位为秒，需要转换为毫秒

    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')

    return `${year}-${month}-${day}`
}
function toYear(time) {
    var date = new Date(time) // 传入的时间单位为秒，需要转换为毫秒

    const year = date.getFullYear()


    return `${year}`
}

function lastMonthToday() {
    var lastMonthToday = new Date(
        new Date().getTime() - 30 * 24 * 60 * 60 * 1000
    );
    var lastMonthYear = lastMonthToday.getFullYear();
    var lastMonth = lastMonthToday.getMonth() + 1;
    var lastMonthDay =
        lastMonthToday.getDate < 10
            ? "0" + lastMonthToday.getDate
            : lastMonthToday.getDate();
    var lastMonthKsrq = lastMonthYear + "-" + lastMonth + "-" + lastMonthDay;

    var nextMonthToday = new Date(
        new Date().getTime() + 30 * 24 * 60 * 60 * 1000
    );
    var nextMonthYear = nextMonthToday.getFullYear();
    var nextMonth = nextMonthToday.getMonth() + 1;
    var nextMonthDay =
        nextMonthToday.getDate < 10
            ? "0" + nextMonthToday.getDate
            : nextMonthToday.getDate();
    var nextMonthJsrq = nextMonthYear + "-" + nextMonth + "-" + nextMonthDay;
}
// lastMonthToday()
//取图片URL中名称
function getImageNameFromURL(url) {
    // 使用split分割URL，并取最后一部分，通常是文件名
    // 然后使用substring去除可能存在的前缀，如"?", "#"或者"/"
    return url.split('/').pop().substring(url.lastIndexOf('/') + 1 || Infinity);
}
//匹配obj的key获取value
function matchingKeys(obj,partialKey){
    const keysWithPartialMatch = Object.keys(obj).filter(key => key.includes(partialKey));
    const values = keysWithPartialMatch.map(key => obj[key]);
    return values
}

export default {
    toDate,
    toDay,
    toYear,
    lastMonthToday,
    getImageNameFromURL,
    matchingKeys
}

